import { useState } from 'react';
import styles from './style.module.scss';
import { FeedCardHeader } from './header';
import { FeedCarousel } from './carousel';
import { FeedLikeButton } from './like-button';
import { FeedComments } from './comments';

export const FeedCard = ({ card }) => {
  const [isLiked, setIsLiked] = useState(card.likedByMe ?? false);
  const [likeCount, setLikeCount] = useState(card.likes ?? 0);
  const [likeLoading, setLikeLoading] = useState(false);
  const [showAllComments, setShowAllComments] = useState(false);
  const [comments, setComments] = useState(card.comments || []);
  const [newComment, setNewComment] = useState('');

  const images = card.images || [];

  const handleLike = () => {
    if (likeLoading) return;
    setLikeLoading(true);

    const csrfToken = document.querySelector('meta[name="csrf-token"]')
      ? document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      : '';

    fetch(`/minha-pagina/feed/${card.id}/like`, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
        'X-CSRF-TOKEN': csrfToken,
      },
      credentials: 'same-origin',
    })
      .then(r => r.json())
      .then(res => {
        setIsLiked(res.liked);
        setLikeCount(res.likes_count);
      })
      .catch(() => {})
      .finally(() => setLikeLoading(false));
  };

  const [commentLoading, setCommentLoading] = useState(false);

  const handleAddComment = () => {
    const text = newComment.trim();
    if (!text || commentLoading) return;

    setCommentLoading(true);

    const csrfToken = document.querySelector('meta[name="csrf-token"]')
      ? document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      : '';

    const challengeId = card.challengeId;

    const body = new URLSearchParams({ description: text });

    fetch(`/minha-pagina/feed/${challengeId}/comment`, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
        'X-CSRF-TOKEN': csrfToken,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      credentials: 'same-origin',
      body,
    })
      .then(r => r.json())
      .then(res => {
        const saved = Array.isArray(res) ? res[0] : res;
        const newEntry = {
          id: saved.id,
          author: saved.user ? saved.user.name : 'Você',
          text: saved.description,
        };
        setComments(prev => [...prev, newEntry]);
        setNewComment('');
      })
      .catch(() => {})
      .finally(() => setCommentLoading(false));
  };

  return (
    <article className={styles.card}>
      <FeedCardHeader
        title={card.title}
        state={card.state}
        city={card.city}
        id={card.id}
        slug={card.slug}
      />
      <FeedCarousel images={images} />
      <div className={styles.cardActions}>
        <FeedLikeButton
          isLiked={isLiked}
          onToggle={handleLike}
          count={likeCount}
        />
      </div>
      <FeedComments
        comments={comments}
        showAllComments={showAllComments}
        onShowAllComments={() => setShowAllComments(true)}
        newComment={newComment}
        onNewCommentChange={setNewComment}
        onAddComment={handleAddComment}
        commentLoading={commentLoading}
      />
    </article>
  );
};
